import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getTimeFromJob(jobId) {
            var meta = {
                clientApiMethod: 'getTimeFromjob',
                input: { jobId: jobId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "time/" + jobId, { meta: meta });
            return response.data;
        },
        async getJobTime(timeId) {
            var meta = {
                clientApiMethod: 'getPartsFromJob',
                input: { partId: timeId },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "time/job-time/" + timeId, { meta: meta });
            return response.data;
        },
        async getTimeReportArticles(jobId) {
            var meta = {
                clientApiMethod: 'getTimeReportArticles',
                input: {},
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => "Feil konfigurasjon i tidsartiklene: " + event.response.data.Message
            }
            var response = await client()
                .get(store.state.apiRouteRoot + `time/time-report-articles?jobId=${jobId ?? ''}`, { meta: meta });
            return response.data;
        },
        async addTimePart(payload) {
            var meta = {
                clientApiMethod: 'addTimePart',
                input: { ...payload },
                successText: i18n.t("servicesystem.responses.created_object",
                    { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client()
                .post(store.state.apiRouteRoot + "time/add", payload, { meta: meta });
            return response.data;
        },
        async updateTime(payload) {
            //todo: client validation
            var meta = {
                clientApiMethod: 'updateJobPart',
                input: payload,
                successText: i18n.t("servicesystem.responses.changed_object",
                    { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client()
                .post(`${store.state.apiRouteRoot}time/detail/update`, payload, { meta: meta });
            return response.data;
        }
    }
}